// utils/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // 상태 정의
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [adminInfo, setAdminInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  // 컴포넌트 마운트 시 세션 확인
  useEffect(() => {
    checkAuthStatus();
  }, []);

  // 세션 상태 확인
  const checkAuthStatus = async () => {
    try {
      const response = await axios.get('/admin/checkSession', { withCredentials: true });
      if (response.data.isAuthenticated) {
        setIsAuthenticated(true);
        setAdminInfo({
          ad_no: response.data.ad_no,
          ad_name: response.data.ad_name
        });
      } else {
        setIsAuthenticated(false);
        setAdminInfo(null);
      }
    } catch (error) {
      console.error('세션 확인 실패:', error);
      setIsAuthenticated(false);
      setAdminInfo(null);
    } finally {
      setLoading(false);
    }
  };

  // 로그인 함수
  const login = async (id, pw) => {
    try {
      const response = await axios.post('/admin/loginProc', { id, pw }, { withCredentials: true });
      if (response.data.result === '성공') {
        setIsAuthenticated(true);
        await checkAuthStatus(); // 세션 정보 갱신
        return { success: true };
      } else {
        setIsAuthenticated(false);
        return { 
          success: false, 
          message: response.data.result 
        };
      }
    } catch (error) {
      console.error('로그인 실패:', error);
      setIsAuthenticated(false);
      return { 
        success: false, 
        message: '로그인 처리 중 오류가 발생했습니다.' 
      };
    }
  };

  // 로그아웃 함수
  const logout = async () => {
    try {
      await axios.post('/admin/logout', {}, { withCredentials: true });
      setIsAuthenticated(false);
      setAdminInfo(null);
    } catch (error) {
      console.error('로그아웃 실패:', error);
    }
  };

  // Provider에 전달할 값
  const value = {
    isAuthenticated,
    adminInfo,
    loading,
    login,
    logout
  };

  // AuthContext.Provider로 감싸서 반환
  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

// useAuth 훅 정의
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === null) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};